import { render, staticRenderFns } from "./FeaturedPeopleListing.vue?vue&type=template&id=0889ad8a&scoped=true"
import script from "./FeaturedPeopleListing.vue?vue&type=script&lang=js"
export * from "./FeaturedPeopleListing.vue?vue&type=script&lang=js"
import style0 from "./FeaturedPeopleListing.vue?vue&type=style&index=0&id=0889ad8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0889ad8a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FeaturedPeopleListing.vue
// module id = 279
// module chunks = 0